import { Button, Card, ListItemButton, Paper, styled } from "@mui/material";

export const SliderComponent = styled(Paper)(() => ({
  borderRadius: "20px 250px 20px 20px",
  background:
    "linear-gradient(5deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 79%, rgb(30, 40, 96) 93%, rgb(49, 31, 91) 100%)",
  color: "white",
}));

export const ButtonComponent = styled(Button)(() => ({
  border: "1px solid #2f6df6",
  borderRadius: "20px",
  background:
    "linear-gradient(to bottom, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 48%, rgb(42, 73, 150) 100%)",
  color: "white",
}));
export const CardImageComponent = styled(Card)(() => ({
  borderRadius: " 100% 0% 100% 0% / 20% 100% 0% 58%",
  borderBottomLeftRadius: "30px",
  borderBottomRightRadius: "30px",
  borderTopRightRadius: "40px",
  clipPath: "polygon(0% 10%, 100% 0%, 100% 99%, 0% 100%)",
}));
export const CustomListItemButton = styled(ListItemButton)(({ theme }) => ({
  width: "100%",
  color: "gray",
"&.Mui-selected": {
  color: "white",
  background:
    "linear-gradient(to right, rgba(115, 85, 176, 0) 0%, rgba(115, 85, 176, 0.1) 50%, rgba(115, 85, 176, 0.71) 100%)",
  borderWidth: "0px 3px 0px 0px",
  borderStyle: "solid",
  borderImage:
    "linear-gradient(to bottom, #FD00FF,white ,#FD00FF,white ,#FD00FF) 1 100%",
},
}));

// Syntax
// const SliderComponent=styled()(()=>({

// }));
